import {useEffect,useState} from 'react';
import type {AuthProviders} from '@reados/contracts';
import {api} from '../api';

export function useAuthProviders(){
 const [providers,setProviders]=useState<AuthProviders|null>(null),[loading,setLoading]=useState(true),[error,setError]=useState(''),[revision,setRevision]=useState(0);
 useEffect(()=>{
  const controller=new AbortController();let active=true;setLoading(true);setError('');
  void api.authProviders(controller.signal).then(value=>{if(active)setProviders(value);}).catch(()=>{if(active)setError('登录方式暂时无法读取，请重试。');}).finally(()=>{if(active)setLoading(false);});
  return()=>{active=false;controller.abort();};
 },[revision]);
 return {providers,loading,error,reload:()=>setRevision(value=>value+1)};
}
